export enum ComObjectChannelEnum {
    GetContext = 'get-com-object-context',
    GetProperty = 'get-com-object-property',
    SetProperty = 'set-com-object-property',
    Invoke = 'invoke-com-object',
    Release = 'release-com-object',
}
